







import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
  components: {}
})

export default class Quote extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;

  @Prop() text: string;
  @Prop() author: string;
}
